<template>
	<div :title="title" class="small-button" :class="{ danger: color === 'danger' }">
		<i :class="icon" />
	</div>
</template>

<script>
export default {
	name: "SmallButton",
	props: ["icon", "title", "color"]
}
</script>

<style scoped>
.small-button {
	width: 40px;
	height: 40px;
	background: #fff;
	border-radius: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 5px;
	transition: all 0.2s ease-in-out;
}

.small-button.danger {
	background: #fff;
}

.small-button:hover,
.small-button:hover i {
	background: var(--blackColor);
	cursor: pointer;
	color: #ffffff;
	transition: all 0.2s ease-in-out;
}

.small-button i {
	color: var(--blackColor);
}
</style>
